module.exports = __webpack_public_path__ + "static/ABA_2020_Winner_Commercial_broker_of_the_year-2639436b62e333e776f506101ae2ff7c.png";